import { useState } from 'react';
import { deleteItemPedido } from '../../services/itemPedidoService';

const useDeleteItemPedido = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const remove = async (id: string) => {
    setLoading(true);
    try {
      await deleteItemPedido(id);
    } catch (err) {
      setError('Falha ao deletar item de pedido');
    } finally {
      setLoading(false);
    }
  };

  return { deleteItemPedido: remove, loading, error };
};

export default useDeleteItemPedido;
